export default __webpack_public_path__ + "static/media/startups.02b6cee3.png";